import { Injectable, NgZone } from '@angular/core';
import { DeviceAndBrowserDetectorService } from './device-and-browser-detector.service';

@Injectable({
  providedIn: 'root',
})
export class TouchScrollLockService {
  constructor(
    private deviceAndBrowserDetectorService: DeviceAndBrowserDetectorService,
    private zone: NgZone,
  ) {}

  public lockPageScrollOnTouchDevices(): void {
    if (this.skipTouchScrollPrevention()) {
      return;
    }
    // to prevent the page from scrolling when the user is interacting with textbox
    document.body.style.position = 'fixed';
  }

  // to prevent the page from scrolling when the user is interacting specific element
  public registerTouchScrollPrevention(element: HTMLElement | null): () => void {
    if (!element || this.skipTouchScrollPrevention()) {
      return () => {};
    }

    const handler = (event: TouchEvent) => {
      event.preventDefault();
    };

    this.zone.runOutsideAngular(() => {
      element.addEventListener('touchmove', handler, {
        passive: false,
      });
    });

    return () => {
      element.removeEventListener('touchmove', handler);
    };
  }

  private skipTouchScrollPrevention(): boolean {
    if (
      !this.deviceAndBrowserDetectorService.isTouchDevice() ||
      this.deviceAndBrowserDetectorService.isSafari()
    ) {
      return true;
    }
    return false;
  }
}
